import React from 'react';
import { useSelectAndLoadCurrentOrder } from 'selectors/order/selectCurrentOrder';
import { UUID } from '../../../types/shared/UUID';
import type { FCWithChildren } from '../../../types/FCWithChildren';

export interface IOrderLoadingGuardProps {
  orderId: UUID;
}

/*
 * Loads an order (IOrderDetailsData).
 * Renders children only when order is defined
 */
export const OrderLoadingGuard: FCWithChildren<IOrderLoadingGuardProps> = ({ orderId, children }) => {
  const {
    fetchStatus: { success },
  } = useSelectAndLoadCurrentOrder(orderId);

  return <>{success && children}</>;
};
